export const appName = "JOYSTICK"

export const appSlogan = "PLAY NOW WIN LATER"

export const appDescription = "JOYSTICK is a next-generation gaming platform built around skill, creativity, and competition."

export const joystickURL = process.env.REACT_APP_WEB_JOYSTICK_ROOT_URL